<script lang="ts" setup>
defineProps({
  actionToTake: String
})
</script>

<template>
  <div class="action-container">
    <img height="20" src="../assets/circle-exclamation-solid.svg" width="auto" />
    <el-text class="card-warning">{{ actionToTake }}</el-text>
  </div>
</template>

<style scoped>
.action-container {
  display: flex;
  gap: 10px;
}

.card-warning {
  margin-left: 5px;
  background: white;
  color: grey;
  font-weight: bold;
}
</style>
